import { InputButton } from '@abbott-components/core';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ComponentProps {
  open: boolean;
  promptMsg: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  processing?: boolean;
  onConfirmClick: () => void;
  onCancelClick: () => void;
}

export default ({
  open,
  promptMsg,
  confirmBtnText,
  cancelBtnText,
  processing,
  onConfirmClick,
  onCancelClick
}: ComponentProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancelClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{'Confirmation'}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>
          {promptMsg}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <InputButton
          name="cancelButton"
          type="button"
          variant="text"
          onClick={onCancelClick}
          disabled={processing}
        >
          {cancelBtnText || 'Cancel'}
        </InputButton>
        <InputButton
          name="discardButton"
          type="button"
          onClick={onConfirmClick}
          disabled={processing}
        >
          {confirmBtnText || 'Confirm'}
        </InputButton>
      </DialogActions>
    </Dialog>
  );
};
